import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import ApiDatePickerField from "../../../components/date/ApiDatePickerField";
import "./VaccinationDateField.css";

/**
 * Vaccination date field — displays DD/MM/YYYY; value/onChange stay YYYY-MM-DD for API.
 * Keeps the existing bordered shell look.
 */
const VaccinationDateField = ({
  id = "dateOfAdministration",
  value = "",
  onChange,
}) => (
  <div style={{ width: "100%" }} className="vaccination-date-field">
    <ApiDatePickerField
      id={id}
      value={value}
      onChange={onChange}
      slotProps={{
        textField: {
          variant: "outlined",
          sx: {
            width: "100%",
            "& .MuiOutlinedInput-root": {
              height: "48px",
              borderRadius: "10px",
              backgroundColor: "#FDFDFD",
              fontSize: "12px",
              fontWeight: 500,
              color: "#1c2c4c",
              "& fieldset": {
                borderColor: "#125386",
              },
              "&:hover fieldset": {
                borderColor: "#125386",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#125386",
                borderWidth: "1px",
              },
            },
          },
        },
      }}
      slots={{
        openPickerIcon: () => (
          <FaCalendarAlt style={{ fontSize: "14px", color: "#0E3F66" }} />
        ),
      }}
    />
  </div>
);

export default VaccinationDateField;
